var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page forbit-cancel-tree" },
    [
      _c(
        "Modal",
        {
          staticClass: "page-modal",
          attrs: {
            width: "50%",
            "mask-closable": false,
            "footer-hide": true,
            title: _vm.$t("newarea.batch"),
            "class-name": "vertical-center-modal",
          },
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _vm.spinShow
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modalContainer modalHeight" },
            [
              _c(
                "Form",
                { attrs: { "label-width": 130, "label-colon": "" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: _vm.$t("area.areaType"), required: "" } },
                    [
                      _c("div", { staticClass: "radio-box" }, [
                        _c(
                          "span",
                          {
                            class: _vm.areaFlag === 2 ? "active-box" : "",
                            on: {
                              click: function ($event) {
                                return _vm.areaTypeChange(2)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("newarea.batch1")) + " ")]
                        ),
                        _c(
                          "span",
                          {
                            class: _vm.areaFlag === 3 ? "active-box" : "",
                            on: {
                              click: function ($event) {
                                return _vm.areaTypeChange(3)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("newarea.batch2")) + " ")]
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                [
                  Number(_vm.areaFlag) === 2
                    ? _c("type2", {
                        ref: "type2",
                        attrs: { "current-node": _vm.currentNode },
                        on: {
                          closeBox: _vm.closeModal,
                          updateTree: _vm.updateTree,
                          changeSpinShow: _vm.changeSpinShow,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                [
                  Number(_vm.areaFlag) === 3
                    ? _c("type3", {
                        ref: "type3",
                        attrs: { "current-node": _vm.currentNode },
                        on: {
                          closeBox: _vm.closeModal,
                          updateTree: _vm.updateTree,
                          changeSpinShow: _vm.changeSpinShow,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content_win" },
        [
          _c("modal", {
            ref: "resultModal",
            attrs: { type: _vm.modalType },
            on: { afterComfirm: _vm.closeModal },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }